import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'controls',
  initialState: {
    allowNavigate: false,
    showHeader: true,
    startTime: null
  },
  reducers: {
    setAllowNavigate: (state, action) => {
      state.allowNavigate = action.payload
    },
    setShowHeader: (state, action) => {
      state.showHeader = action.payload
    },
    setStartTime: (state, action) => {
      state.startTime = action.payload
    }
  }
})

export const { setAllowNavigate, setShowHeader, setStartTime } = slice.actions

export default slice.reducer
